<div class="container select-restu">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 tot-pad">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end"
        class="col-md-12 col-sm-12 col-xs-12 col-lg-12" *ngIf="apiResponseReceived">

        <img style="position: absolute; right: 15px; top: 15px;  cursor: pointer;"
          src="../../../../assets/icons/Info Circle.png" alt="" (click)="closeSelectRestaurantModal()" />

      </div>

      <div style="margin-bottom: 35px" class="addeve-sty" *ngIf="apiResponseReceived">
        Select restaurant
      </div>

      <div *ngIf="restaurantListNearBy.length==0">
        <h3 style="font-size: 20px !important;margin-top: 15px !important;margin-bottom: 20px;">No Restaurants Found
          Nearby.</h3>
      </div>

      <div *ngIf="restaurantListNearBy.length>0" class="select-restur">
        <div class="gry-col-sr" *ngFor="let val of restaurantListNearBy">
          <div style="" class="row select_restro_list">
            <div class="select_restro_contsiner">
              <div class="background-img ">
                <div class="image-container" style="position: relative;">
                  <img style="" [src]="val.logo" />

                  <span class="restoDistance"
                    *ngIf="convertToMiles(val?.distance) == 0">{{convertToMiles(val?.distance)}} mi</span>
                  <span class="restoDistance"
                    *ngIf="convertToMiles(val?.distance) > 0">{{convertToMiles(val?.distance) | number:'1.1-2'}}
                    mi</span>
                </div>
              </div>


              <div style="" class=" select_restro_details">
                <div class="rest-text" style="overflow-wrap: anywhere;">{{val.restaurantName}}</div>
                <div class="col-md-12 col-sm-12 col-xs-12 ">
                  <div class="address-text">
                    <div><img class="map-img" src="../../../../assets/icons/map-pin.svg"></div>
                    <div style="padding-left: 5px;">{{val.address?.length>40 ? val.address.slice(0,40)+'...' : val.address}}</div>
                  </div>
                </div>
              </div>



              <form [formGroup]="selectForm" class="selectForm">
                <div class="check_box_styl_1">
                  <!-- <input style="cursor: pointer;" [checked]="val?.selected"
                  (change)="checkRestaurant($event,val)" [value]="val?._id" type="checkbox" class="select-res-checkbox"/> -->
                  <mat-checkbox [checked]="val?.selected"
                  (change)="checkRestaurant($event,val)" [value]="val?._id" class="something"></mat-checkbox>
                    <!-- <mat-checkbox class="kjahhd"></mat-checkbox> -->
                </div>
              </form>
            </div>
          </div>
          <div class="">
            <div class="" [ngClass]="{'btn-aling':val.isFreeDelivery || val.isFreeCoachMeals,'notAvailable': val.isFreeDelivery && val.isFreeCoachMeals}">
              <div class="">
                <button class="f-delivary withoutHand" *ngIf="val.isFreeDelivery">Free Delivery</button>
              </div>

              <div class="" *ngIf="!val.isFreeDelivery">
                <button class="f-delivary withoutHand" *ngIf="val.isFreeCoachMeals">Free Coaches Meals</button>
              </div>

              <div class="text-center">
                <button [ngClass]="{'viewDetailsAvailable': !val.isFreeDelivery && !val.isFreeCoachMeals,'v-details': val.isFreeDelivery || val.isFreeCoachMeals }" (click)="onclickviewSelectRestro(val._id)">
                  View Details
                </button>
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex justify-content-center" *ngIf="val.isFreeDelivery">
            <button class="f-delivary withoutHand" *ngIf="val.isFreeCoachMeals">Free Coaches Meals</button>
          </div>
        </div>
      </div>


      <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="apiResponseReceived">
        <button mat-raised-button color="warn" class="nex-btn"
          [disabled]="!disableRestaurantsNext || !selectForm.value.check" (click)="onclicknext()">Next </button>
      </div>
    </div>
</div>
